
// import './blocks/stickyHeader.js'
import './modules/history.js'

import './modules/ruins-slider.js'
import './modules/expeditionsSlider.js'
import './modules/ruin-filter.js'
import './modules/ruin-tab.js'
import './modules/ruin-map.js'
import './modules/isAccordion.js'




